import { render, staticRenderFns } from "./DelUser.vue?vue&type=template&id=e62a4c80"
import script from "./DelUser.vue?vue&type=script&lang=js"
export * from "./DelUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports